"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTest = IsTest;
exports.SetNowTest = SetNowTest;
exports.get_now_sec = get_now_sec;
exports.get_now_ms = get_now_ms;
exports.Sleep = Sleep;
let NOW_TEST_MS = 0;
function IsTest() {
    return process.env['NODE_ENV'] === 'test';
}
/**
 * Under testing conditions, we can override the value of
 * get_now_ms, which can help some time-based conditions.
 * If its left at '0', its ignored and it returns the system
 * time.
 */
function SetNowTest(now_ms) {
    if (!IsTest()) {
        throw new Error("Must be in test");
    }
    NOW_TEST_MS = now_ms;
}
function get_now_sec() {
    return Math.floor(get_now_ms() / 1000);
}
function get_now_ms() {
    if (IsTest() && NOW_TEST_MS > 0) {
        return NOW_TEST_MS;
    }
    return new Date().getTime();
}
async function Sleep(delay_ms) {
    await new Promise(resolve => setTimeout(resolve, delay_ms));
}
